export const adaptVirtualNetworksResponse = (response) => {
  return response?.response || [];
};
